<template>
  <div class="register-hc">
    <div class="step1" v-if="step == 1">
      <van-cell-group>
        <van-field v-model="form.companyName" :maxlength="100" label="公司全称" placeholder="请输入公司全称" />
        <van-field v-model="form.displayName" :maxlength="100" label="公司简称" placeholder="请输入公司简称" />
        <van-field
          v-model="area"
          clickable
          readonly
          @click="showPickerAddr = true"
          v-if="province"
          label="所在地区"
          placeholder="请选择地区"
        >
          <span slot="right-icon">
            <van-icon name="arrow" />
          </span>
        </van-field>
        <van-field v-model="form.address" :maxlength="100" label="详细地址" placeholder="请填写详细地址" />
        <van-field
          v-model="scale"
          clickable
          readonly
          @click="showPickerSize = true"
          label="公司规模"
          placeholder="请选择规模"
        >
          <span slot="right-icon">
            <van-icon name="arrow" />
          </span>
        </van-field>
        <van-field v-model="form.businessVolume" label="年营业额" placeholder="请输入金额">
          <span slot="right-icon" style="color:#333;">万</span>
        </van-field>
        <van-field
          v-model="startYear"
          clickable
          readonly
          @click="showPickerYear = true"
          label="成立年份"
          placeholder="请选择成立年份"
        >
          <span slot="right-icon">
            <van-icon name="arrow" />
          </span>
        </van-field>
      </van-cell-group>
    </div>
    <div class="step2" v-if="step == 2">
      <van-cell-group>
        <van-field v-model="form.contacts" label="联系人" placeholder="请输入联系人" />
        <van-field
          v-model="userSf"
          clickable
          readonly
          @click="showPickerSF = true"
          label="联系身份"
          placeholder="请选择身份"
        >
          <span slot="right-icon">
            <van-icon name="arrow" />
          </span>
        </van-field>
        <van-field v-model="form.contactsEmail" label="联系邮箱" placeholder="请输入邮箱" />
        <van-field v-model="form.contactsCellphone" label="手机号" placeholder="请输入手机号" />
        <van-field v-model="form.imgVerifyCode" :maxlength="8" label="图形验证码" placeholder="请输入验证码">
          <div slot="right-icon" class="pic-code">
            <img
              :src="'/hd-weixin/api/v1/user/registers/imageVerifyCode?v=' + vCode"
              @click="changeVcode"
              alt
            />
            <span @click="changeVcode">换一换</span>
          </div>
        </van-field>
        <van-field
          v-model="form.verificationCode"
          :maxlength="8"
          label="手机验证码"
          placeholder="请输入验证码"
        >
          <div slot="right-icon" class="tel-code">
            <span v-if="!isSendSms" @click="getSmsCode">获取验证码</span>
            <span v-if="isSendSms" style="color:#999">{{sendNum}}秒后重新获取</span>
          </div>
        </van-field>
      </van-cell-group>
    </div>
    <div class="step3" v-if="step == 3">
      <van-cell-group>
        <van-field v-model="form.businessLicence" label="营业执照" placeholder="请输入营业执照号" />
        <van-field v-model="form.legalPersonName" label="法人姓名" placeholder="请输入法人姓名" />
      </van-cell-group>
      <div class="inner-cell">
        <dl>
          <dt>法人身份证</dt>
          <dd>
            <van-uploader :after-read="onReadSf">
              <img v-if="!this.form.legalPersonID" src="../img/sf.png" alt />
              <img v-if="this.form.legalPersonID" :src="this.form.legalPersonID" alt />
            </van-uploader>
          </dd>
        </dl>
      </div>
      <div class="inner-cell">
        <dl>
          <dt>营业执照</dt>
          <dd>
            <van-uploader :after-read="onReadYy">
              <img v-if="!this.form.businessLicense" src="../img/yy.png" alt />
              <img v-if="this.form.businessLicense" :src="this.form.businessLicense" alt />
            </van-uploader>
          </dd>
        </dl>
      </div>
    </div>
    <div class="step4" v-if="step == 4">
      <div class="apply-info">
        <img src="../img/ok.png" alt />
        <h4>申请完成</h4>
        <p>猎企入驻申请成功！</p>
      </div>
      <div class="apply-contact">
        <p>1-3个工作日内，将有官方人员联系您，请保持联系电话畅通！</p>
        <p>
          客服电话：021-80250888
          <br />联系时间：上午 9:00到12:00 - 下午 13:30到18:00
        </p>
      </div>
      <!-- 最后一页要处理背景色 所以btn拿上来 -->
      <div class="btns">
        <van-button type="primary" v-if="step == 4" @click="close">确认</van-button>
      </div>
    </div>
    <div class="btns" v-if="step < 4">
      <van-button type="primary" v-if="step < 3" @click="nextStep">下一步</van-button>
      <van-button type="primary" v-if="step == 3" @click="submit">提交</van-button>
    </div>
    <!-- 地址 -->
    <van-popup v-model="showPickerAddr" position="bottom" v-if="columnsAddr.length">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="columnsAddr"
        @cancel="showPickerAddr = false"
        @confirm="onConfirm"
        @change="onChange"
      />
    </van-popup>
    <!-- 公司规模 -->
    <van-popup v-model="showPickerSize" position="bottom">
      <van-picker
        show-toolbar
        value-key="value"
        :columns="columnsSize"
        @cancel="showPickerSize = false"
        @confirm="onConfirmSize"
      />
    </van-popup>
    <!-- 成立年份 -->
    <van-popup v-model="showPickerYear" position="bottom">
      <van-picker
        show-toolbar
        value-key="value"
        :columns="columnsYear"
        @cancel="showPickerYear = false"
        @confirm="onConfirmYear"
      />
    </van-popup>
    <!-- 联系身份 -->
    <van-popup v-model="showPickerSF" position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="columnsSF"
        @cancel="showPickerSF = false"
        @confirm="onConfirmSF"
      />
    </van-popup>
  </div>
</template>

<style lang="scss" scoped>
.register-hc {
  // 隐藏最上方1px边框
  margin-top: -1px;
  padding-bottom: 30px;

  .pic-code,
  .tel-code {
    position: relative;

    img {
      position: relative;
      top: -2px;
      right: 5px;
      display: inline-block;
      width: 50px;
      height: 28px;
      background: #f5f5f5;
    }

    span {
      color: #22baa5;
      font-size: 14px;
    }
  }

  .step3 {
    .inner-cell {
      padding: 10px 16px;
      padding-top: 15px;

      dl {
        dt {
          font-size: 16px;
          line-height: 24px;
        }

        dd {
          padding: 0 16px;
          margin-top: 10px;

          img {
            width: 100%;
          }
        }
      }
    }
  }

  .step4 {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #f5f5f5;

    .btns {
      margin-top: 35px;
    }
  }

  .apply-info {
    img {
      width: 75px;
      margin: 35px auto;
      display: block;
    }

    h4 {
      font-size: 18px;
      line-height: 20px;
      text-align: center;
    }

    p {
      text-align: center;
      color: #666;
      margin-top: 10px;
    }
  }

  .apply-contact {
    p {
      margin: 0 15px;
      margin-top: 20px;
      color: #666;
    }
  }

  .btns {
    .van-button {
      width: 100%;
      font-size: 16px;
    }

    margin: 0 15px;
    margin-top: 20px;
  }
}
</style>
<style lang="scss">
.register-hc {
  .van-cell-group {
    input {
      font-size: 16px;
    }
  }

  .van-field {
    padding-top: 15px;

    span {
      font-size: 16px;
    }
  }
}
</style>

<script>
import { range } from "@/common/utils";
import {
  isExistCompanyName,
  isExistDisplayName,
  sendPhoneVerifyCode,
  checkCellPhone,
  getLink,
  uploadCompanyImage,
  registerCompany
} from "@/api/account";
import { isMobile, isEmail } from "@/common/utils";

import { mapState } from "vuex";

import md5 from "md5";

// const province = window.METADATA.province;
// const citys = window.METADATA.areaList.city_list;

const companySize = [
  { id: "0", value: "1-10人" },
  { id: "1", value: "11-20人" },
  { id: "2", value: "21-50人" },
  { id: "3", value: "51-100人" },
  { id: "4", value: "101-200人" },
  { id: "5", value: "201-500人" },
  { id: "6", value: "500人以上" }
];

export default {
  name: "register-hc-module",
  data() {
    return {
      step: 1,
      isSendSms: false,
      sendNum: 60,
      province: null,
      citys: null,
      vCode: new Date().getTime(),
      showPickerAddr: false,
      showPickerSize: false,
      showPickerYear: false,
      showPickerSF: false,
      columnsSF: [
        {
          id: 1,
          name: "职员"
        },
        {
          id: 2,
          name: "合伙人"
        },
        {
          id: 3,
          name: "创始人"
        }
      ],
      columnsYear: range(
        new Date().getFullYear(),
        new Date().getFullYear() - 30,
        -1
      ),
      columnsSize: companySize,
      columnsAddr: [],
      area: "",
      scale: "",
      startYear: "",
      userSf: "",
      form: {
        companyName: "",
        displayName: "",
        provinceId: "",
        cityId: "",
        address:"",
        companyScale: "",
        businessVolume: "",
        establishYear: "",
        contacts: "",
        contactsIdentity: "",
        contactsEmail: "",
        contactsCellphone: "",
        imgVerifyCode: "",
        verificationCode: "",
        businessLicence: "",
        legalPersonName: "",
        legalPersonID: "",
        legalPersonAttachment: "",
        businessLicense: "",
        licenseAttachment: ""
      }
    };
  },
  watch: {
    cities() {
      this.setCities();
    }
  },
  components: {},
  computed: {
    ...mapState({
      cities: state => state.comp.cities || {}
    })
  },
  methods: {
    setCities() {
      this.province = window.METADATA.province;
      this.citys = window.METADATA.areaList.city_list;
      this.columnsAddr = [
        {
          values: this.province,
          className: "column1"
        },
        {
          values: this.citys[this.province[0].id],
          className: "column2",
          defaultIndex: 0
        }
      ];
    },
    //营业执照上传
    onReadYy(file) {
      let params = new FormData(); //创建form对象
      params.append("fileUpload", file.file); //通过append向form对象添加数据//第一个参数字符串可以填任意命名，第二个根据对象属性来找到file
      uploadCompanyImage(params)
        .then(res => {
          this.form.businessLicense = res.data.remoteUrl;
          this.form.licenseAttachment = res.data.url;
        })
        .catch(err => {});
    },
    //身份证上传
    onReadSf(file) {
      let params = new FormData(); //创建form对象
      params.append("fileUpload", file.file); //通过append向form对象添加数据//第一个参数字符串可以填任意命名，第二个根据对象属性来找到file
      uploadCompanyImage(params)
        .then(res => {
          this.form.legalPersonID = res.data.remoteUrl;
          this.form.legalPersonAttachment = res.data.url;
        })
        .catch(err => {});
    },
    onConfirmSF(item) {
      this.userSf = item.name;
      this.form.contactsIdentity = item.id;
      this.showPickerSF = false;
    },
    onConfirmYear(item) {
      this.startYear = item;
      this.form.establishYear = item;
      this.showPickerYear = false;
    },
    onConfirmSize(item) {
      this.scale = item.value;
      this.form.companyScale = item.id;
      this.showPickerSize = false;
    },
    onConfirm(values, index) {
      this.form.provinceId = values[0].id;
      this.form.cityId = values[1].id;
      this.area = values[0].name + " " + values[1].name;
      this.showPickerAddr = false;
    },
    onChange(picker, values) {
      picker.setColumnValues(1, this.citys[values[0].id]);
    },
    changeVcode() {
      this.vCode = new Date().getTime();
    },
    close() {
      if(WeixinJSBridge){
        WeixinJSBridge.call('closeWindow');
      }else{
        window.close();
      };
    },
    submit() {
      // 最后一步提交

      if (this.step == 3 && this.checkCertificate()) {
        registerCompany(this.form)
          .then(res => {
            this.step++;
          })
          .catch(err => {});
      }
    },
    checkCompanyName() {
      // 公司名称;
      if (!this.form.companyName.trim()) {
        this.$toast("请填写公司全称");
        return;
      }
      // 公司简称;
      if (!this.form.displayName.trim()) {
        this.$toast("请填写公司简称");
        return;
      }
      // 所在地区
      if (!this.form.cityId) {
        this.$toast("请选择地区");
        return;
      }
      // 详细地址
      if (!this.form.address.trim()){
        this.$toast("请填写详细地址");
        return;
      };
      // 公司规模
      if (!this.form.companyScale) {
        this.$toast("请选择公司规模");
        return;
      }

      // 年营业额
      if (!/^\d+(\.\d+)?$/.test(this.form.businessVolume)) {
        this.$toast("请填写正确年营业额");
        return;
      }
      // 成立年份
      if (!this.form.establishYear) {
        this.$toast("请选择成立年份");
        return;
      }
      return true;
    },
    checkContact() {
      // 联系人
      if (!this.form.contacts.trim()) {
        this.$toast("请填联系人");
        return;
      }
      // 身份
      if (!this.form.contactsIdentity) {
        this.$toast("请选择身份");
        return;
      }
      // 邮箱
      if (!this.form.contactsEmail.trim()) {
        this.$toast("请填写邮箱");
        return;
      }

      if (!isEmail(this.form.contactsEmail.trim())) {
        this.$toast("邮箱格式不正确");
        return;
      }

      if (!this.checkMobile()) {
        return;
      }

      if (!this.form.verificationCode.trim()) {
        this.$toast("请填写手机验证码");
        return;
      }
      return true;
    },
    nextStep() {
      //post接口默认支持全局loading
      //但这个按钮是get请求，点按钮的时候手动调用loading
      //请求结束自动关闭
      //this.$store.commit('comp/POST_LOADING',true);
      if (this.step == 1 && this.checkCompanyName()) {
        //第一步需要判断公司名称 和 简称是否重复
        this.$store.commit("comp/POST_LOADING", true);
        Promise.all([
          isExistCompanyName({
            companyName: this.form.companyName
          }),
          isExistDisplayName({
            displayName: this.form.displayName
          })
        ]).then(values => {
          let cname = values[0],
            dname = values[1];
          if (cname.data) {
            this.$toast("该公司名称已经存在");
            return;
          }
          if (dname.data) {
            this.$toast("该公司简称已经存在");
            return;
          }
          this.step++;
        });
      }

      if (this.step == 2 && this.checkContact()) {
        checkCellPhone({
          contactsCellphone: this.form.contactsCellphone,
          verificationCode: this.form.verificationCode
        })
          .then(res => {
            this.step++;
          })
          .catch(err => {});
      }
    },
    checkCertificate() {
      if (!this.form.businessLicence.trim()) {
        this.$toast("请填写营业执照号");
        return;
      }
      if (!this.form.legalPersonName.trim()) {
        this.$toast("请填写法人姓名");
        return;
      }
      if (!this.form.legalPersonAttachment || !this.form.legalPersonID) {
        this.$toast("请上传身份证");
        return;
      }
      if (!this.form.licenseAttachment || !this.form.businessLicense) {
        this.$toast("请上传营业执照");
        return;
      }
      return true;
    },
    checkMobile() {
      if (!this.form.contactsCellphone.trim()) {
        this.$toast("请填写手机号");
        return;
      }
      if (!isMobile(this.form.contactsCellphone.trim())) {
        this.$toast("手机号格式不正确");
        return;
      }

      if (!this.form.imgVerifyCode.trim()) {
        this.$toast("请输入验证码");
        return;
      }
      return true;
    },
    countDown() {
      this.isSendSms = true;
      let timer = null;
      let fn = () => {
        clearTimeout(timer);
        if (this.sendNum <= 1) {
          timer = null;
          this.isSendSms = false;
          this.sendNum = 60;
          return;
        }
        this.sendNum--;

        timer = setTimeout(fn, 1000);
      };
      timer = setTimeout(fn, 1000);
    },
    getSmsCode() {
      if (!this.checkMobile()) return;
      getLink()
        .then(link => {
          const { nonce, realm } = link.data;
          let ph = this.form.contactsCellphone;
          let a1 = ph + ":" + realm;
          let a2 = "POST:/v1/user/company/registers/sendPhoneVerifyCode";
          let ha2 = md5(a2);
          let ha1 = md5(a1);
          let key = md5(ha1 + ":" + nonce + ":" + ha2);
          sendPhoneVerifyCode({
            phoneNumber: this.form.contactsCellphone,
            imageVerifyCode: this.form.imgVerifyCode,
            authorizeCode: key
          })
            .then(res => {
              this.countDown();
            })
            .catch(err => {
              this.changeVcode();
            });
        })
        .catch(err => {});
    }
  },
  created() {
    if (window.METADATA.areaList) {
      this.setCities();
    }
  }
};
</script>
